import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HeaderComponent from '../../../components/HeaderComponent';
import TalentSidebar from './TalentSidebar'; 

// Import your page components
import MyAuditionsPage, { RecommendedAuditionsPage, OngoingAuditionsPage, ArchivedAuditionsPage } from './MyAuditionsPage';
import TransactionHistoryPage from './TransactionHistoryPage';
import ChangePasswordPage from '../ChangePasswordPage';
import TalentDashboard from './TalentDashboard';
import MyApplicationRow from './MyApplicationRow';
import MyProfilePage from './MyProfilePage';
import PlatformFeedback from './PlatformFeedback';
import CastingFeedback from './CastingFeedback';
import CastingDirectorProfile from '../../../components/audition-booking-wizard/CastingDirectorProfile';
import CastingDirectorCard from '../../../components/audition-booking-wizard/CastingDirectorCard';
import './TalentDashboardLayout.css'; 
import FooterComponent from '../../../components/FooterComponent';
import TalentBillingPage from './TalentBillingPage';
import CastingDirectorProfilePage from '../castingdirector/CastingDirectorProfilePage';
import MeetingsPage from '../../../components/dashboard/MeetingsPage';
// import MeetingPage from '../../MeetingPage';

const TalentDashboardLayout = () => {
    return (
        <div className="tdl-dashboard-root">
            {/* Standard Global Header */}
            <HeaderComponent />

            {/* Main Flex Layout Wrapper */}
            <div className="tdl-layout-wrapper">
                
                {/* Fixed Sidebar Area */}
                <aside className="tdl-sidebar-area">
                    <TalentSidebar /> 
                </aside>

                {/* Dynamic Main Content Area */}
                <main className="tdl-main-area">
                    <Routes>
                        <Route index element={<Navigate to="overview" replace />} /> 
                        <Route path="overview" element={<TalentDashboard />} />
                        <Route path="my-audition" element={<MyApplicationRow />} />
                        {/* <Route path="my-auditions" element={<MyAuditionsPage />} /> */}
                        {/* <Route path="recommended-auditions" element={<RecommendedAuditionsPage />} /> */}
                        {/* <Route path="ongoing-auditions" element={<OngoingAuditionsPage />} /> */}
                        {/* <Route path="archived-auditions" element={<ArchivedAuditionsPage />} /> */}
                        {/* <Route path="transaction-history" element={<TransactionHistoryPage />} /> */}
                        <Route path="profile" element={<MyProfilePage />} />
                        <Route path="profile/:id" element={<MyProfilePage />} />
                        <Route path="ChangePasswordPage" element={<ChangePasswordPage />} />
                        <Route path="platform-feedback" element={<PlatformFeedback />} />
                        <Route path="casting-feedback" element={<CastingFeedback />} />
                        {/* <Route path="casting-director-profile/:id" element={<CastingDirectorProfile />} /> */}
                        {/* <Route path="casting-director-card" element={<CastingDirectorCard />} /> */}
                        <Route path="billing" element={<TalentBillingPage />} />
                        <Route path="cd-profile/:id" element={<CastingDirectorProfilePage />}/>
                        <Route path="meetings" element={<MeetingsPage />}/>
                        {/* <Route path="meeting/:roomName"element={<MeetingPage />} /> */}
                    

                    </Routes>
                </main>
            </div>
             <FooterComponent />
        </div>
    );
};

export default TalentDashboardLayout;